import Recommendation from './Recommendation';

export default Recommendation;
